import React from 'react'
import { Link } from 'react-router-dom'
import SEO from '../common/SEO'
import HeaderKorlo from '../common/header/HeaderKorlo'
import TimeNetwork from '../dashboard/TimeNetwork'
import timedata from '../data/dashboard/sfhh@4.json'
import { FiCpu, FiGlobe, FiBarChart2, FiArrowRight } from 'react-icons/fi'

const KorloLandingPage = () => {
  return (
    <>
      <SEO title='Korlo AI' />
      <main className='page-wrapper'>
        <HeaderKorlo btnStyle='btn-small' />

        {/* Hero Section */}
        <section className='korlo-hero'>
          <div className='container'>
            <div className='row align-items-center'>
              <div className='col-lg-6 col-12'>
                <div className='hero-content'>
                  <span className='hero-badge'>AI-Powered Language Learning</span>
                  <h1 className='hero-title'>
                    The Personalized<br />
                    <span className='gradient-text'>Polyglot AI</span><br />
                    Experience
                  </h1>
                  <p className='hero-description'>
                    Our language learning platform is being engineered for an AI future
                    — built for students, teachers, and professionals who demand more.
                  </p>
                  <div className='hero-cta'>
                    <Link to='/contact' className='btn-primary-korlo'>
                      Get in Touch <FiArrowRight />
                    </Link>
                    <Link to='/about' className='btn-secondary-korlo'>
                      Learn More
                    </Link>
                  </div>
                </div>
              </div>
              <div className='col-lg-6 col-12'>
                <div className='hero-visual'>
                  <div className='network-container'>
                    <TimeNetwork
                      height={500}
                      width={500}
                      data={timedata}
                      colorOne={'#38a378'}
                      colorTwo={'#d4a548'}
                      radius={3}
                      timeStep={300}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Divider */}
        <div className='korlo-divider' />

        {/* Features Section */}
        <section className='korlo-features'>
          <div className='container'>
            <div className='section-header'>
              <span className='section-label'>Why Korlo AI</span>
              <h2 className='section-title'>Built for the Future of Language Learning</h2>
              <p className='section-subtitle'>
                Harnessing large language models and data analytics to create
                an unbeatable experience in acquiring new language skills.
              </p>
            </div>
            <div className='row g-4'>
              <div className='col-lg-4 col-md-6'>
                <div className='feature-card'>
                  <div className='feature-icon'>
                    <FiCpu />
                  </div>
                  <h3 className='feature-title'>AI-Driven Content</h3>
                  <p className='feature-text'>
                    Personalized lessons generated by advanced language models that adapt
                    to your proficiency level and learning pace in real time.
                  </p>
                </div>
              </div>
              <div className='col-lg-4 col-md-6'>
                <div className='feature-card'>
                  <div className='feature-icon icon-orange'>
                    <FiBarChart2 />
                  </div>
                  <h3 className='feature-title'>Data-Driven Insights</h3>
                  <p className='feature-text'>
                    Cutting-edge analytics provide constant feedback, helping you understand
                    your progress and optimize your learning path.
                  </p>
                </div>
              </div>
              <div className='col-lg-4 col-md-6'>
                <div className='feature-card'>
                  <div className='feature-icon icon-blue'>
                    <FiGlobe />
                  </div>
                  <h3 className='feature-title'>Universal Access</h3>
                  <p className='feature-text'>
                    Mobile-first design ensures the best language learning tools are
                    accessible to every student, teacher, and professional worldwide.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Divider */}
        <div className='korlo-divider' />

        {/* CTA Section */}
        <section className='korlo-cta'>
          <div className='container'>
            <div className='cta-inner'>
              <h2 className='cta-title'>Ready to Transform Language Learning?</h2>
              <p className='cta-text'>
                We're building the next generation of AI-powered language education.
                Get in touch to learn more about Korlo AI.
              </p>
              <Link to='/contact' className='btn-primary-korlo'>
                Contact Us <FiArrowRight />
              </Link>
            </div>
          </div>
        </section>

        {/* Footer */}
        <footer className='korlo-footer'>
          <div className='container'>
            <div className='footer-inner'>
              <span className='footer-copyright'>
                &copy; {new Date().getFullYear()} Korlo Holdings LLC
              </span>
              <div className='footer-links'>
                <Link to='/about'>About</Link>
                <Link to='/contact'>Contact</Link>
              </div>
            </div>
          </div>
        </footer>
      </main>
    </>
  )
}

export default KorloLandingPage
